import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from './config.service';
import { PasswordPolicy } from '../config.token';

export interface PasswordResetSelfRequest {
  login: string;
  email: string;
  documento: string;
}

export interface PasswordResetResponse {
  success: boolean;
  message?: string;
  code?: string;
  data?: PasswordPolicy;
}

@Injectable({ providedIn: 'root' })
export class PasswordResetService {
  private readonly http = inject(HttpClient);
  private readonly configService = inject(ConfigService);

  requestByAdmin(usuarioId: string): Observable<PasswordResetResponse> {
    return this.http.post<PasswordResetResponse>(
      this.url('passwordResetAdminRequestUrl'),
      { usuarioId },
    );
  }

  requestByUser(request: PasswordResetSelfRequest): Observable<PasswordResetResponse> {
    return this.http.post<PasswordResetResponse>(
      this.url('passwordResetSelfRequestUrl'),
      {
        login: request.login.trim(),
        email: request.email.trim(),
        documento: PasswordResetService.normalizeDocumento(request.documento),
      },
    );
  }

  confirm(token: string, password: string): Observable<PasswordResetResponse> {
    return this.http.post<PasswordResetResponse>(
      this.url('passwordResetConfirmUrl'),
      { token, password },
    );
  }

  getPolicy(token: string): Observable<PasswordResetResponse> {
    return this.http.post<PasswordResetResponse>(
      this.url('passwordResetPolicyUrl'),
      { token },
    );
  }

  static normalizeDocumento(value: string | null | undefined): string {
    return String(value ?? '').replace(/\D/g, '');
  }

  static messageFromError(error: unknown, fallback: string): string {
    if (!(error instanceof HttpErrorResponse)) {
      return fallback;
    }

    const body = error.error as {
      message?: string;
      error?: string;
      code?: string;
      errors?: Array<{ description?: string; message?: string }>;
    } | null;
    return body?.message
      || body?.error
      || body?.errors?.[0]?.description
      || body?.errors?.[0]?.message
      || fallback;
  }

  private url(name: string): string {
    const url = this.configService.getApiUrl(name);
    if (!url) {
      throw new Error(`Endpoint de redefinição de senha não configurado: ${name}`);
    }
    return url;
  }
}
